import styled from 'styled-components';
import media from 'styled-media-query';
import Img from 'gatsby-image';
import LocalizedLink from '../LocalizedLink';

export const PostItemLink = styled(LocalizedLink)`
  text-decoration: none;
  display: block;
  margin-bottom: var(--space);
  opacity: 0.4;

  :hover {
    opacity: 1.0;
  }

  ${media.greaterThan('small')`
    margin-bottom: 0;
  `}

`;

export const PostItemWrapper = styled.section`
  align-items: center;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background: var(--bg-light);
`;

export const PostItemImg = styled(Img)`
  width: 100%;
 
`;
